import React from 'react';
import { Padding, Separator, Flex } from '../../base/layout-components';
import Text, { Inline } from '../../base/Text';
import Icon from '../../base/Icon';
import { useGetEffectiveContirbutorsAvatars } from './effective-contributors.service';
import { Link, Avatar } from '@material-ui/core';

export const EffectiveContributors = ({
  contributors = [],
  effectiveContributors = [],
  branchName = '',
  prUrl
}) => {
  const { avatars, indirect, restAvatars } = useGetEffectiveContirbutorsAvatars(
    {
      contributors,
      effectiveContributors
    }
  );

  return (
    <Flex width='30rem'>
      <Padding padding='small' width='100%'>
        <Text size='large' color='black' pb='1rem'>
          Contributors
        </Text>
        <Separator direction='horizontal' width='100%' height='1px'></Separator>
        <Padding padding='small'></Padding>
        <Flex pb='small' items='center'>
          <Icon name='Branch' size='small' />
          <Inline
            size='medium'
            pb='0.3rem'
            pl='0.5rem'
            pr='1rem'
            ellipsisAfter='100%'
          >
            {branchName}
          </Inline>
        </Flex>

        {avatars.map(({ url, id, name, email }) => (
          <Flex items='center' key={id} pb='small'>
            <Avatar size='small' src={url} alt='' />
            <Inline size='medium' pl='1rem' pr='1rem' ellipsisAfter='100%'>
              {name ? `${name} (${email})` : email}
            </Inline>
          </Flex>
        ))}
        {restAvatars > 0 ? (
          <Flex items='center' pb='medium'>
            <Inline size='medium' pl='1rem' color='chambray'>
              +{restAvatars} more
            </Inline>
          </Flex>
        ) : null}
        {avatars.length === 0 ? (
          <Text size='large' pb='1rem'>
            There is no effective work
          </Text>
        ) : null}
        {indirect > 0 || prUrl ? (
          <>
            <Padding padding='x-small'></Padding>
            <Separator
              direction='horizontal'
              width='100%'
              height='1px'
            ></Separator>
            <Padding padding='x-small'></Padding>
          </>
        ) : null}

        {indirect > 0 ? (
          <>
            <Text size='medium' color='shuttleGray' pt='1rem' pb='1rem'>
              {indirect} more people contributed indirectly to this branch.
            </Text>
            <Padding padding='x-small'></Padding>
          </>
        ) : null}

        {prUrl ? (
          <Link onClick={() => window.open(prUrl)}>View on Git</Link>
        ) : null}
      </Padding>
    </Flex>
  );
};
